export default __webpack_public_path__ + "static/media/Punto_00_Finocchietti_DEU_Def.6085ed89.aac";